import type { ErrorPayload } from "./types.js";

export function toErrorPayload(error: unknown): ErrorPayload {
  if (error instanceof Error) {
    return {
      name: error.name || "Error",
      message: error.message || String(error),
      stack: error.stack,
      cause: (error as Error & { cause?: unknown }).cause,
    };
  }

  if (typeof error === "string") {
    return { name: "Error", message: error };
  }

  if (error && typeof error === "object" && "message" in error) {
    const record = error as Record<string, unknown>;
    return {
      name: String(record.name ?? "Error"),
      message: String(record.message ?? "Unknown error"),
      stack: typeof record.stack === "string" ? record.stack : undefined,
    };
  }

  return { name: "Error", message: String(error) };
}

export function createEventId(): string {
  if (typeof crypto !== "undefined" && "randomUUID" in crypto) {
    return crypto.randomUUID();
  }
  return `evt_${Date.now()}_${Math.random().toString(36).slice(2, 11)}`;
}
